/**
 * @file vinCheck.mjs
 */

import { createElement } from "commonAssets/js/helpers";
import { loading } from "commonAssets/js/constants";
import { loadingGif, modal, validateField } from "commonAssets/js/helpers";

import { VINValidator } from "./VINValidator/index.mjs";
import { ReCaptchaHandler } from "./ReCaptchaHandler/index.mjs";
import { VINLookup } from "./VINLookup/index.mjs";

// UI Elements and Constants
const UI = {
    vinInput: "#vinInput",
    checkVinBtn: "#checkVinBtn",
    vinResult: "#vinResult",
    vinCheckerContainer: "#vinCheckerContainer",
};

// Helper Functions
const showLoading = () => loadingGif(loading, "show");
const hideLoading = () => loadingGif(loading, "hide");
const showError = (message) => modal("Error", message);
const resetVinInput = (input) => {
    input.value = "";
    input.classList.remove("is-valid", "is-invalid");
};

const vinCheck = async (claim) => {
    console.log("Init VIN Check");

    const form = document.querySelector("#guard");
    if (!form) {
        setTimeout(() => vinCheck(claim), 1);
        return;
    }
    form.classList.add("d-none");

    createVinCheckerContainer(claim);
    addVinCheckerHandler(claim);
};

// Function to create VIN Checker UI
function createVinCheckerContainer(claim) {
    const form = document.querySelector("#guard");
    const vinCheckerContainer = createElement("div", {
        id: "vinCheckerContainer",
    });

    const path = window.location.pathname.split("/")[1];
    const vinChecker = {
        "vin-check-form": {
            title: "VIN Checker",
            description:
                "Enter the VIN to check for eligibility for a warranty claim.",
            instructions:
                "Please complete this form to: (1) identify whether a vehicle is eligible for extended coverage or the annual sunroof cleaning program, (2) determine the amount of eligible coverage; and (3) obtain necessary information to submit a claim for payment.",
            placeholder: "Enter the VIN",
            button: "Check VIN",
        },
        "submit-claim-form": {
            title: "Submit Claim",
            description: "Please fill out the form below to submit a claim.",
            instructions:
                "Please complete this form and attach all relevant documents to submit a claim for payment.",
            placeholder: "Enter the VIN",
            button: "Submit Claim",
        },
    }[path];

    vinCheckerContainer.innerHTML = `
        <div class="row">
            <div class="col-12">
                <div class="alert alert-info text-center fw-bold mb-3" role="alert">
                    For any questions pertaining to your claim or about the portal,
                    please email us at <a href="mailto:info@SunroofDrainVINPortal.com" class="text-primary">info@SunroofDrainVINPortal.com</a>.
                </div>
            </div>
            <div class="border rounded my-5 mx-auto col-md-6 offset-md-3">
                <div class="">
                    <h4 class="my-3">${vinChecker.title}</h4>
                    <p>${vinChecker.description}</p>
                    <p class="callout callout-info">${vinChecker.instructions}</p>
                    <div class="mb-3">
                        <label for="vinInput" class="form-label">
                            Vehicle Identification Number (VIN)
                            <span class="text-danger">*</span>
                            <span class="error"></span>
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            id="vinInput"
                            data-validate="required"
                            placeholder="${vinChecker.placeholder}"
                            maxlength="17"
                            pattern="^[A-HJ-NPR-Z0-9]{17}$"
                            title="VIN must be 17 characters long and contain only letters A-H, J-N, P-R, and numbers 0-9."
                            required>
                    </div>
                    <button class="btn btn-primary" id="checkVinBtn" type="button">${vinChecker.button}</button>
                    <div id="vinResult" class="mt-3"></div>
                </div>
            </div>
        </div>`;

    form.insertAdjacentElement("beforebegin", vinCheckerContainer);
}

// Function to add VIN Checker handler
function addVinCheckerHandler(claim) {
    const checkVinBtn = document.querySelector(UI.checkVinBtn);

    checkVinBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        showLoading();

        const input = document.querySelector(UI.vinInput);
        const button = e.target;

        const validator = new VINValidator(input, button);
        if (!validator.validate()) return;

        const vin = input.value;

        // VIN Validation before API call
        if (!validateField(input)) {
            hideLoading();
            showError("Invalid VIN. Please check and try again.");
            return;
        }

        // Execute reCAPTCHA and VIN lookup
        ReCaptchaHandler.execute((token) => {
            const vinLookup = new VINLookup(claim, vin);
            vinLookup.lookup.token = token;
            vinLookup.execute();
        });

        hideLoading();

        resetVinInput(input);
    });
}

export default vinCheck;
